import { render, staticRenderFns } from "./DemoBar.vue?vue&type=template&id=bdff37f4&scoped=true"
import script from "./DemoBar.vue?vue&type=script&lang=js"
export * from "./DemoBar.vue?vue&type=script&lang=js"
import style0 from "./DemoBar.vue?vue&type=style&index=0&id=bdff37f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdff37f4",
  null
  
)

export default component.exports